<template>
  <!-- 横向排列 模式 type -> 1  =>  文字 -->
  <!-- 横向排列 模式 type -> 2  =>  图片2 (1-20) || 文字-->
  <div class="g_switch-4">
    <h3 class="tc-b" v-if="title && title!='特码'">
      <span class="t_wei">{{title}}</span>
    </h3>
    <div :class="getLayout()">
      <v-switch-item1
        :selectRule="selectRule"
        :chip="chip"
        class="switch-1"
        v-for="(item, index) in filterLianmaList(list, '0')"
        :key="'item' + index"
        :item="item"
        :type="type"
        :class="'w-' + columns"
        :isSelectAll="isSelectAll"
        :current="current"
        :jq="jq"
        :yq="yq"
        :haomaduipeng="section1"
        :duipengsx="duipengsx"
      />
    </div>
    <div class="g_switch-wrap g_switch-wrap-number-weishu" v-if="isLianmaType()">
      <v-switch-item1
        :selectRule="selectRule"
        :chip="chip"
        class="switch-1"
        v-for="(item, index) in filterLianmaList(list, '1')"
        :key="'item' + index"
        :item="item"
        :type="type"
        :class="'w-' + columns"
        :isSelectAll="isSelectAll"
        :current="current"
        isWeishu
      />
    </div>
    <div style="float: left;height: 300px;line-height: 300px;margin: 0px 0.8%;" v-if="isHaoMaDuiPeng()">
      碰
    </div>
    <div :class="getLayout()" v-if="isHaoMaDuiPeng()">
      <v-switch-item1
        :selectRule="selectRule"
        :chip="chip"
        class="switch-1"
        v-for="(item, index) in filterLianmaList(list, '0')"
        :key="'item' + index"
        :item="item"
        :type="type"
        :class="'w-' + columns"
        :isSelectAll="isSelectAll"
        :current="current"
        :jq="jq"
        :yq="yq"
        :haomaduipeng="section2"
        :duipengsx2="duipengsx2"
      />
    </div>
    <div style="margin: 5px 0px;width: 50%;float: left;text-align: center;" v-if="isHaoMaDuiPeng()">
      <b @click="onQuickPlay('鼠')">鼠</b>
      <b @click="onQuickPlay('牛')">牛</b>
      <b @click="onQuickPlay('虎')">虎</b>
      <b @click="onQuickPlay('兔')">兔</b>
      <b @click="onQuickPlay('龙')">龙</b>
      <b @click="onQuickPlay('蛇')">蛇</b>
      <b @click="onQuickPlay('马')">马</b>
      <b @click="onQuickPlay('羊')">羊</b>
      <b @click="onQuickPlay('猴')">猴</b>
      <b @click="onQuickPlay('鸡')">鸡</b>
      <b @click="onQuickPlay('狗')">狗</b>
      <b @click="onQuickPlay('猪')">猪</b>
    </div>
    <div style="margin: 5px 0px;float: right;width: 50%;text-align: center;" v-if="isHaoMaDuiPeng()">
      <b @click="onQuickPlay2('鼠')">鼠</b>
      <b @click="onQuickPlay2('牛')">牛</b>
      <b @click="onQuickPlay2('虎')">虎</b>
      <b @click="onQuickPlay2('兔')">兔</b>
      <b @click="onQuickPlay2('龙')">龙</b>
      <b @click="onQuickPlay2('蛇')">蛇</b>
      <b @click="onQuickPlay2('马')">马</b>
      <b @click="onQuickPlay2('羊')">羊</b>
      <b @click="onQuickPlay2('猴')">猴</b>
      <b @click="onQuickPlay2('鸡')">鸡</b>
      <b @click="onQuickPlay2('狗')">狗</b>
      <b @click="onQuickPlay2('猪')">猪</b>
    </div>
    <div style="margin:5px 0px 5px 0px" v-if="subtitle=='二肖' || subtitle=='三肖' || subtitle=='四肖' || subtitle=='五肖' || subtitle=='六肖'">
      <Checkbox v-model="jq" label="家禽" border size="small" @click="shengxiao('jq')"></Checkbox>
      <Checkbox v-model="yq" label="野禽" border size="small" @click="shengxiao('yq')"></Checkbox>
    </div>
  </div>
</template>

<script>
  // 横向-单行流式布局
  import VSwitchItem1 from "../switch-item/g_switch-item4";
  import Vue from "../../../utils/bus";
  import objectPath from 'object-path';
  import { mapState } from "vuex";
  import { Checkbox } from 'element-ui';

  export default {
    name: "g_switch-4",
    components: {
      VSwitchItem1,
      Checkbox
    },
    props: {
      selectRule: {
        type: Function,
        default: () => true
      },
      current: Object,
      chip: String,
      horizontalType: {
        type: Number,
        default: 1
        // 横向 1 -> 1 文字                  + rate               + select
        // 横向 2 -> 3 数字(1-20) || 文字     + rate               + select
        // 横向 3 -> 5 数字(1-20)                                 + select
      },
      columns: {
        type: Number,
        default: 5
      },
      title: {
        type: String,
      },
      subtitle: {
        type: String,
      },
      list: {
        type: Array,
        default() {
          return [];
        }
      },
      layout: {
        type: String,
      }
    },
    data() {
      return {
        isSelectAll: false,
        key: 0,
        jq: false,
        yq: false,
        section1:'section1',
        section2:'section2',
        duipengsx:'',
        duipengsx2:''
      };
    },
    methods: {
      onQuickPlay(play) {
        this.duipengsx = play;
      },
      onQuickPlay2(play) {
        this.duipengsx2 = play;
      },
      shengxiao(type) {
        if(type=='jq'){
          this.jq = true;
        }else if(type=='yq'){
          this.yq = true;
        }
      },
      // 如果是连码的混合对碰，list数据不一样
      filterLianmaList(list, index) {
        if (this.subtitle === '二全中' || this.subtitle === '二中特' || this.subtitle === '二中特X' || this.subtitle === '特串') {
          if (this.playTypeRadio == 5 || this.playTypeRadio == 6) {
            return list[index];
          }
        }
        return list;
      },
      // 如果是连码的混合对碰，布局有不同的改动
      isLianmaType() {
        if (this.subtitle === '二全中' || this.subtitle === '二中特' || this.subtitle === '二中特X' || this.subtitle === '特串') {
          if (this.playTypeRadio == 5) return true;
        }
        return false;
      },
      isHaoMaDuiPeng() {
        if (this.subtitle === '二全中' || this.subtitle === '二中特' || this.subtitle === '二中特X' || this.subtitle === '特串') {
          if (this.playTypeRadio == 6) return true;
        }
        return false;
      },
      getLayout() {
        const currentValue = objectPath.get(this.current, 'value');
        if (currentValue === 5 || currentValue === 6 || currentValue === 11 ||
          (currentValue === 8 && (this.playTypeRadio == 3 || this.playTypeRadio == 5))
        ) {
          return 'g_switch-wrap g_switch-wrap-yixiaoweishu';
        }
        if (currentValue === 7 ||
          (currentValue === 8 && (this.playTypeRadio == 4))
        ) {
          return 'g_switch-wrap g_switch-wrap-number-weishu';
        }
         if (currentValue === 8 && this.playTypeRadio == 6) {
           //号码对碰
          return 'g_switch-wrap-number g_switch-wrap-number-number';
        }
        // 普通number号码
        if (this.layout === 'isNumber') {
          return 'g_switch-wrap-number';
        }
        // 正特、特码下面的排序表格
        if (this.layout === 'isZhengte') {
          return 'g_switch-wrap g_switch-wrap-number-zhengte';
        }
        return 'g_switch-wrap';
      }
    },
    created() {
      Vue.$on("changSelect", (item) => {
        if (item == this.title || item == "all") {
          if (this.isSelectAll) {
            this.isSelectAll = false;
            //Vue.$emit("resetInput");
          } else {
            this.isSelectAll = true;
          }
        }
      });
      Vue.$on("reset", () => {
        this.isSelectAll = false;
        this.jq = false;
        this.yq = false;
      });
      Vue.$on("resetDefault", () => {
        this.isSelectAll = false;
        this.jq = false;
        this.yq = false;
      })
    },
    computed: {
      ...mapState({
        playTypeRadio: state => state.home.playTypeRadio,
      }),
      type() {
        // 将列表项 映射 成正确的item 1 -> 1、2 -> 3
        let _type = 1;
        switch (this.horizontalType) {
          case 1:
            _type = 1;
            break;
          case 2:
            _type = 3;
            break;
          case 3:
            _type = 5;
            break;
          case 4:
            _type = 4;
            break;
        }
        return _type;
      }
    }
  };
</script>

<style scoped lang="stylus">
  $border-color = #E6E6E6;

  .g_switch-4 {
    h3 {
      width: 100%;
      height: 26px;
      border: 1px solid $border-color;
      position: relative;
      font-size: 13px;
      box-sizing: border-box;
      text-align: center;
      font-weight: bold;
      line-height: 26px;
      margin-bottom: 2px;
      background: linear-gradient(#FEFEFE, #F0F0F0);

      span {
        display: inline-block;
        position: relative;

        &:before, &:after {
          top: 50%;
          display: block;
          content: '';
          height: 1px;
          position: absolute;
        }

        &:before {
          left: -45px;
        }

        &:after {
          right: -45px;
        }
      }
    }

    .g_switch-wrap-number,
    .g_switch-wrap {
      font-size: 13px;
      position: relative;
      overflow: hidden;
      border-top: 1px solid $border-color;
      border-right: 1px solid $border-color;

      &:after {
        left: 0;
        width: 100%;
        height: 1px;
        bottom: 0;
        content: '';
        display: block;
        position: absolute;
        background-color: $border-color;
      }

      .switch-1 {
        float: left;
        box-sizing: border-box;
        border-left: 1px solid $border-color;
      }

      .switch-1:last-child {
        box-sizing: border-box;
        border-right: 1px solid $border-color;
      }

      .w-2 {
        width: 50%;
      }

      .w-3 {
        width: 33%;
      }

      .w-4 {
        width: 25%;
      }

      .w-5 {
        width: 20%;
      }
    }

    // 全局有号码玩法的容器

    .g_switch-wrap-number,
    .g_switch-wrap-number-zhengte,
    .g_switch-wrap-number-weishu,
    .g_switch-wrap-yixiaoweishu {
      /*margin-bottom: 5px;*/
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      height: 300px;
    }
    .g_switch-wrap-number.g_switch-wrap-number-number {
        width: 48%;
        float: left;
    }
    // 设置单独的高度

    .g_switch-wrap-yixiaoweishu {
      height: 180px;
    }

    // 正特 特码的高度

    .g_switch-wrap-number-zhengte {
      height: 120px;
    }

    // 正特 特码的高度

    .g_switch-wrap-number-weishu {
      height: 170px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/c_game-switch/switch-list/g_switch-4.vue